/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsImageTextHover = {
	init: function($section) {

    // Selectors
    const $block = $section.find('.images-with-text-hover__content');
    const $prevButton = $section.find('.images-with-text-hover__nav--prev');
    const $nextButton = $section.find('.images-with-text-hover__nav--next');
    const $promoSlider = $section.find('[data-images-with-text-hover-slider]');

    const $Slider = $promoSlider.flickity({
      initialIndex: 0,
      contain: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
      draggable: true
    });
    $block.hover(function(){
      $(this).removeClass('closed');
    },function(){
      $(this).addClass('closed');
    })
    $Slider.on( 'settle.flickity', function() {
      $Slider.flickity('resize');
    });

    $prevButton.on('click', function () {
      $Slider.flickity('previous');
    });

    $nextButton.on('click', function () {
      $Slider.flickity('next');
    });
	},
  blockSelect: function($section, blockId) {
    var $Slider = $section.find('[data-images-with-text-hover-slider]');

    var slideIndex = $('#shopify-section-' + blockId).data('promo-index');

    $Slider.flickity('select', slideIndex, true, true);
  },
	unload: function($section) {
    var $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
    $('.images-with-text-hover__nav--prev').off();
    $('.images-with-text-hover__nav--next').off();

	}
}

/******/ })()
;